import { AwsRum, AwsRumConfig } from "aws-rum-web";

let awsRum: AwsRum | null = null;

const APP_MONITOR_ID = "66032ee2-1621-4b23-b596-88574dfaf10e";
const IDENTITY_POOL_ID = "us-east-1:83059ea3-6954-4111-815a-4c615100a7f0";
const REGION = "us-east-1";

if (process.env.NODE_ENV === "production") {
  try {
    const config: AwsRumConfig = {
      sessionSampleRate: 1,
      identityPoolId: IDENTITY_POOL_ID,
      endpoint: `https://dataplane.rum.${REGION}.amazonaws.com`,
      telemetries: ["errors", "http", "performance"],
      allowCookies: true,
      enableXRay: false,
    };

    awsRum = new AwsRum(APP_MONITOR_ID, "1.0.0", REGION, config);
  } catch (error) {
    console.error("Failed to initialize CloudWatch RUM:", error);
  }
}

export { awsRum };
